import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useEffect } from "react";
import ArticleList from "../article/ArticleList";
import CardList from "../card/CardList";
import { articlestocards, pushToDataLayer, impressionsGA } from "../../util";

var SearchResults = function SearchResults(props) {
  var isGrid = props.isGrid,
      results = props.results,
      total = props.total,
      pageChange = props.pageChange,
      Products = props.Products,
      currentPage = props.currentPage,
      fields = props.fields,
      _props$layout = props.layout,
      layout = _props$layout === void 0 ? {} : _props$layout,
      setDataSource = props.setDataSource,
      isRetail = props.isRetail,
      hasLoadedOnce = props.hasLoadedOnce,
      setHasLoadedOnce = props.setHasLoadedOnce; //searching by query since isSearch is not called within scope

  if ((props === null || props === void 0 ? void 0 : props.query) != "") {
    var _props$results;

    var ecommerceObj = {
      event: 'productImpression',
      ecommerce: {
        //due to limited data being passed into the search results page, fields are filled with what we can use
        impressions: props === null || props === void 0 ? void 0 : (_props$results = props.results) === null || _props$results === void 0 ? void 0 : _props$results.map(function (product, index) {
          var _urlParse$, _urlParse$2;

          var urlParse = product === null || product === void 0 ? void 0 : product.PageUrl.split("/");
          var sku = product === null || product === void 0 ? void 0 : product.PageUrl.split("=");
          var catName = "";

          if (urlParse[1] == "shop") {
            catName = "CB_RETAIL_STORE";
          } else if (urlParse[1] == "menu") {
            catName = "CB_FOOD_STORE";
          } else if (urlParse[1] == "catering") {
            catName = "CB_FOOD_CATERING";
          } else {
            catName;
          }

          var productPrice = "";

          if ((product === null || product === void 0 ? void 0 : product.Price) != null) {
            productPrice = product === null || product === void 0 ? void 0 : product.Price.toString();
          }

          return {
            name: product === null || product === void 0 ? void 0 : product.Title,
            id: sku[1] || (product === null || product === void 0 ? void 0 : product.Id),
            price: productPrice,
            section: urlParse[1] || '',
            category: urlParse[2] || '',
            'dimension1': ((_urlParse$ = urlParse[3]) === null || _urlParse$ === void 0 ? void 0 : _urlParse$.includes("?")) ? '' : urlParse[3],
            'dimension2': ((_urlParse$2 = urlParse[4]) === null || _urlParse$2 === void 0 ? void 0 : _urlParse$2.includes("?")) ? '' : urlParse[4],
            'dimension3': 'In Stock',
            'dimension5': catName,
            'dimension6': 'Regular Price',
            'variant': (product === null || product === void 0 ? void 0 : product.ProductVariantModel) || '',
            'list': 'PLP',
            position: index + 1
          };
        })
      }
    };

    if (!hasLoadedOnce) {
      pushToDataLayer(ecommerceObj);
    }
  } else {
    if (!hasLoadedOnce) {
      impressionsGA(props === null || props === void 0 ? void 0 : props.Products);
    }
  }

  useEffect(function () {
    if (!hasLoadedOnce) {
      setHasLoadedOnce(true);
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-search-results"
  }, isGrid ? /*#__PURE__*/React.createElement(CardList, _extends({}, props, {
    cards: isRetail ? results : articlestocards(results),
    totalCardsInRow: 3,
    cardDisplayType: "list",
    layout: layout,
    isProduct: true,
    isRetail: isRetail
  })) : /*#__PURE__*/React.createElement(ArticleList, {
    articleResults: results,
    total: total,
    getArticles: pageChange,
    setDataSource: function setDataSource() {
      return "";
    },
    setPageSize: function setPageSize() {
      return "";
    },
    currentPage: currentPage,
    fields: fields,
    isSearch: true
  }));
};

export default SearchResults;